import * as React from 'react'
import './index.css'
import { Checkbox as ReactCheckbox } from '@mui/material'

/**
 * @param props
 * @param props.style
 * @return {JSX.Element}
 * @constructor
 */
function CheckedIcon (props) {
  const { style } = props
  return (
    <svg
      style={style}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='16'
        height='16'
        rx='3.2'
        fill='#E15EC4'
      />
      <path
        d='M6.39996 11.0667C6.39942 11.0667 6.39889 11.0667 6.39835 11.0667C6.29169 11.0662 6.18982 11.0235 6.11462 10.9473L3.98129 8.78085C3.82609 8.62351 3.82822 8.37019 3.98556 8.21499C4.14289 8.06033 4.39676 8.06193 4.55142 8.21926L6.40156 10.0987L11.4501 5.05018C11.6064 4.89392 11.8597 4.89392 12.016 5.05018C12.1722 5.20645 12.1722 5.4598 12.016 5.61607L6.68262 10.9494C6.60796 11.0246 6.50609 11.0667 6.39996 11.0667Z'
        fill='white'
      />
    </svg>
  )
}

/**
 * @param props
 * @param props.iconStyle
 * @return {JSX.Element}
 * @constructor
 */
export default function Checkbox ({
  iconStyle,
  ...rest
}) {
  return (
    <ReactCheckbox
      type='checkbox'
      className='checkbox'
      color='highlight'
      checkedIcon={
        <CheckedIcon style={iconStyle} />
      }
      sx={{
        '& .MuiSvgIcon-root': {
          height: '1rem',
          width: '1rem'
        }
      }}
      {...rest}
    />
  )
}
